import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector, useDispatch } from 'react-redux';
import { loadUser, updatePaymentFailedRetry } from '../../actions/userActions'
import { useHistory } from 'react-router';
import { url } from '../../config';
import { FormattedMessage, useIntl } from "react-intl";


function PaymentReNew(props) {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch()
  const history = useHistory()


  useEffect(() => {
    if (props?.data) {
      if (props?.data?.is_payment_failed_retry == '1') {
        setShowModal(true)
      } else {
        setShowModal(false)
      }
    }
  }, [props])


  //update-payment-failed-retry
  const handleSubmit = (type) => {
    if (type == 'cancel') {
      setShowModal(false)
      dispatch(updatePaymentFailedRetry())
      dispatch(loadUser())
    } else {
      setShowModal(false)
      dispatch(updatePaymentFailedRetry())
      history.push(url + `/plan-details`);
      dispatch(loadUser())
    }
  }



  return (
    <div className="container mt-5">
      {showModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" style={{ borderRadius: '15px' }}>
                <div className="modal-body text-center p-4" style={{ backgroundColor: 'white', borderRadius: '10px' }}>
                  <h5 className="mb-3" style={{ fontWeight: '600', color: '#e61313ff' }}>
                    {""}
                    <FormattedMessage id="PaymentReNewTop" defaultMessage="PaymentReNewTop" />
                  </h5>

                  <p className="text-muted mb-4" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    <FormattedMessage id="PaymentReNewMain" defaultMessage="PaymentReNewMain" />

                    <a style={{ color: 'black' }}><FormattedMessage id='PaymentReNewMainSecond' defaultMessage='PaymentReNewMainSecond' /></a>

                    {/* <FormattedMessage id="PaymentReNewMainSecond" defaultMessage="PaymentReNewMainSecond"/> */}
                    <FormattedMessage id="PaymentReNewMainThree" defaultMessage="PaymentReNewMainThree" />

                  </p>

                  <a
                    className="btn-sm mr-2 btn btnRound_Line"
                    style={{
                      fontSize: '15px',
                      fontWeight: '500',
                      borderRadius: '8px',
                      // color:'white',
                      marginRight: '10px'
                    }}
                    onClick={() => { handleSubmit("cancel") }}
                  >
                    <FormattedMessage id="CancelPopu" defaultMessage="CancelPopu" />
                  </a>

                  <a
                    className="btn btn-primary btn-sm btnFUll_Bg"
                    style={{
                      fontSize: '15px',
                      fontWeight: '500',
                      borderRadius: '8px',
                      color: 'white'
                    }}
                    onClick={() => { handleSubmit('update') }}
                  >
                    <FormattedMessage id="UpdatePaymentMethod" defaultMessage='UpdatePaymentMethod' />
                  </a>

                  <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                    <FormattedMessage id="QuestionsPaymentRenew" defaultMessage="QuestionsPaymentRenew" />
                    <a
                      href="mailto:info@cevaheer.com"
                      style={{ color: '#6c63ff', textDecoration: 'none' }}
                    >
                      info@cevaheer.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default PaymentReNew